module.exports = __webpack_public_path__ + "img/faq.3957fdb4.png";